import { slugify } from "@/utils/slugify";
import { FieldTypes, TextFieldProps } from "@/utils/types";
import { Label } from "./Label";
import { ChangeEvent } from "react";

interface TextProps extends TextFieldProps {
  type: FieldTypes;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
}

export const Text = ({
  className,
  defaultValue,
  description,
  disabled,
  id,
  label,
  onChange,
  placeholder,
  readOnly,
  hideLabel,
  required,
  type,
  value,
}: TextProps) => {
  const fieldId = `${label ? slugify(label) : "input"}_${id}`;
  const fieldArgs = {
    name: fieldId,
    id: fieldId,
    disabled,
    required,
    readOnly,
    value,
    defaultValue,
    placeholder,
  };
  return (
    <label
      htmlFor={fieldId}
      className={`formField${className ? ` ${className}` : ""} ${type}${
        disabled ? " disabled" : ""
      } w-full block`}
    >
      <div>
        <Label
          label={label}
          description={description}
          className={hideLabel ? "hidden" : undefined}
        />
        <input
          {...fieldArgs}
          type={type}
          onChange={onChange}
          className="w-full h-[44px] rounded-[30px] px-6 bg-white"
        />
      </div>
    </label>
  );
};
